export default __webpack_public_path__ + "static/media/cctv-camera.faca9211.png";